
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';



@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }
  canActivate() {
    return this.authService.checkSession().pipe(
      map((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          return true;
        }
        this.router.navigate(['/fooldal']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/fooldal']);
        return of(false);
      })
    );
  }

};
